<button (click)="handleClick()" [class.active]="isActive()" [disabled]="disabled()">
	<mat-icon [fontSet]="icon().fontSet" [fontIcon]="icon().fontIcon" />
</button>
